import React from "react";
import { useTranslation } from "react-i18next";

const CRFlag = (props) => (
  <svg viewBox="0 0 30 20" width="24" height="16" aria-hidden="true" {...props}>
    <rect width="30" height="20" fill="#002B7F" />
    <rect y="4" width="30" height="4" fill="#FFFFFF" />
    <rect y="8" width="30" height="4" fill="#CE1126" />
    <rect y="12" width="30" height="4" fill="#FFFFFF" />
    <rect y="16" width="30" height="4" fill="#002B7F" />
  </svg>
);

const USFlag = (props) => (
  <svg viewBox="0 0 30 20" width="24" height="16" aria-hidden="true" {...props}>
    <rect width="30" height="20" fill="#B22234" />
    <g fill="#FFFFFF">
      <rect y="2" width="30" height="2" />
      <rect y="6" width="30" height="2" />
      <rect y="10" width="30" height="2" />
      <rect y="14" width="30" height="2" />
      <rect y="18" width="30" height="2" />
    </g>
    <rect width="12" height="10.77" fill="#3C3B6E" />
    <g fill="#FFFFFF">
      {Array.from({ length: 5 }).map((_, r) =>
        Array.from({ length: 6 }).map((__, c) => {
          const evenRow = r % 2 === 0;
          if (!evenRow && c === 5) return null;
          const x = (evenRow ? 1 : 2) + c * 2;
          const y = 1 + r * 2;
          return <circle key={`${r}-${c}`} cx={x} cy={y} r="0.25" />;
        })
      )}
    </g>
  </svg>
);

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const active = i18n.language?.startsWith("es") ? "es" : "en";

  const setLang = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("lang", lng);
    document.documentElement.lang = lng;
  };

  return (
    <div className="lang-switcher">
      <button
        className={`lang-btn ${active === "es" ? "active" : ""}`}
        onClick={() => setLang("es")}
        title="Español (Costa Rica)"
        aria-label="Cambiar a Español"
      >
        <CRFlag className="flag-svg" />
        <span className="lang-code">ES</span>
      </button>
      <button
        className={`lang-btn ${active === "en" ? "active" : ""}`}
        onClick={() => setLang("en")}
        title="English (USA)"
        aria-label="Switch to English"
      >
        <USFlag className="flag-svg" />
        <span className="lang-code">EN</span>
      </button>
    </div>
  );
}
